import React from "react";

const FleetCardSkeleton = ({ count = 4 }) => (
  <div className="ibfcs-strip" aria-hidden="true" aria-busy="true">
    {Array.from({ length: count }, (_, index) => (
      <div className="ibfcs-card" key={`fleet-skeleton-${index}`}>
        <div className="ibfcs-image ibfcs-shimmer" />
        <div className="ibfcs-body">
          <div className="ibfcs-line ibfcs-line-title ibfcs-shimmer" />
          <div className="ibfcs-line ibfcs-line-tag ibfcs-shimmer" />
          <div className="ibfcs-line ibfcs-line-spec ibfcs-shimmer" />
          <div className="ibfcs-line ibfcs-line-spec ibfcs-shimmer" />
          <div className="ibfcs-line ibfcs-line-spec ibfcs-line-short ibfcs-shimmer" />
          <div className="ibfcs-btn ibfcs-shimmer" />
        </div>
      </div>
    ))}
  </div>
);

export default FleetCardSkeleton;
